import React from "react";

import { FLAGS, useBoolFlag } from "../../../services/featureFlags";
import CreateEditJobPage from "./CreateEditJob";
import JobCreateFlowPage from "./JobCreateFlow";

export default function AddJobRoute() {
  const jobCreateV2 = useBoolFlag(FLAGS.WEB_JOB_CREATE_V2);
  return jobCreateV2 ? <JobCreateFlowPage /> : <CreateEditJobPage />;
}
